/*
 * Bundle blocks (snippets/bundle-gifts-list.liquid is the shared list).
 * The chosen gift flavor is written into the product form's gift_variant_id field,
 * which ProductForm adds to the cart as a free gift (Theme settings → Program gift).
 *
 * <bundle-product-gifts>  "Bundle: one set"       – one list for the whole product.
 * <variant-bundle-gifts>  "Bundle: variant cards" – a card per variant; variant switching
 *                         is handled by <variant-bundle-picker> (theme.js).
 */
(() => {
  const PICKER_INPUT = '.product__gifts--product-variants input[type="radio"]';

  // Variant id of the first gift product with a picker inside container, or ''
  const resolveGiftVariantId = (container) => {
    const giftProduct = container?.querySelector('[data-gift-product]');
    if (!giftProduct) return '';

    let variants = [];
    try {
      variants = JSON.parse(giftProduct.querySelector('[data-gift-variants]')?.textContent || '[]');
    } catch {
      variants = [];
    }
    if (!variants.length) return '';

    const checked = Array.from(giftProduct.querySelectorAll(`${PICKER_INPUT}:checked`));
    const matched = variants.find((variant) =>
      checked.every((radio) => variant[`option${radio.dataset.optionPosition}`] === radio.value)
    );
    const fallback = variants.find((variant) => variant.available) || variants[0];

    return String((matched || fallback).id);
  };

  const setGiftVariantId = (productFormId, value) => {
    const giftInput = document.getElementById(productFormId)?.querySelector('input[name="gift_variant_id"]');
    if (giftInput) giftInput.value = value;
  };

  if (!customElements.get('bundle-product-gifts')) {
    class BundleProductGifts extends HTMLElement {
      connectedCallback() {
        this.update = this.update.bind(this);
        this.onChange = (event) => {
          if (event.target.matches(PICKER_INPUT)) this.update();
        };
        this.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      update() {
        setGiftVariantId(this.dataset.productFormId, resolveGiftVariantId(this));
      }
    }

    customElements.define('bundle-product-gifts', BundleProductGifts);
  }

  if (!customElements.get('variant-bundle-gifts')) {
    class VariantBundleGifts extends HTMLElement {
      connectedCallback() {
        this.onCardClick = this.onCardClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.update = this.update.bind(this);

        this.addEventListener('click', this.onCardClick);
        this.addEventListener('change', this.onChange);

        // <variant-bundle-picker> toggles .is-active without firing change events
        this.observer = new MutationObserver(this.update);
        this.querySelectorAll('.variant-bundle__variant').forEach((item) => {
          this.observer.observe(item, { attributes: true, attributeFilter: ['class'] });
        });

        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onCardClick);
        this.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }

      get activeCard() {
        return this.querySelector('.variant-bundle__variant.is-active')?.closest('.variant-bundle-gifts__card') || null;
      }

      // A click anywhere in a card (not only the header) selects that bundle
      onCardClick(event) {
        if (event.target.closest('.variant-bundle__variant')) return;

        const card = event.target.closest('.variant-bundle-gifts__card');
        const header = card?.querySelector('.variant-bundle__variant');
        if (!header || header.classList.contains('is-active')) return;

        header.click();
      }

      onChange(event) {
        if (event.target.matches(PICKER_INPUT)) this.update();
      }

      update() {
        setGiftVariantId(this.dataset.productFormId, resolveGiftVariantId(this.activeCard));
      }
    }

    customElements.define('variant-bundle-gifts', VariantBundleGifts);
  }
})();
